import { useQuery } from 'react-query';
import {
  getAiPromptQuestionById,
  getAiPromptQuestions,
  getAiPromptQuestionsForAdmin
} from '../services/aiSettingAction';

export const useAiPromptList = type => {
  return useQuery({
    queryKey: ['aiPromptList', type],
    queryFn: async () => {
      const res = await getAiPromptQuestions(type);
      return res.data.questions;
    },
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    retry: 1
  });
};

export const useAiPromptQuestion = id => {
  return useQuery({
    queryKey: ['aiPromptQuestion', id],
    queryFn: async () => {
      const res = await getAiPromptQuestionById(id);
      return res.data.question;
    },
    enabled: !!id,
    refetchOnWindowFocus: false,
    retry: 1
  });
};

export const useAdminAiPromptQuestions = type => {
  return useQuery({
    queryKey: ['adminAiPromptList', type],
    queryFn: async () => {
      const res = await getAiPromptQuestionsForAdmin(type);
      return res.data.questions;
    },
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 60000,
    retry: 1
  });
};
